import React from "react";

const LegalData = () => (
  <section className="w-full bg-light-6 py-8 px-6">
    <h2 className="text-xl font-bold text-dark-1 mb-4">4. Données personnelles</h2>
    <ul className="list-disc list-inside text-light-1 space-y-2">
      <li>Les données collectées sont utilisées uniquement pour le fonctionnement de la plateforme.</li>
      <li>Elles ne sont jamais revendues à des tiers.</li>
      <li>Vous disposez d’un droit d’accès, de rectification et de suppression.</li>
    </ul>
    <p className="mt-3 text-light-1">
      📧 Pour exercer vos droits : [email DPO ou contact dédié]
    </p>
  </section>
);

export default LegalData;
